import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TenantMgmtListComponent} from './tenant-mgmt-list.component';
import { TenantDetailsComponent } from './tenant-details/tenant-details.component';

const routes: Routes = [
  {
    path: '',
    component: TenantMgmtListComponent,
    title: 'Tenant'
  },
  {
    path: ':tenantId',
    component: TenantDetailsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantMgmtListRoutingModule {
}
